import React from 'react';
import IconButton from 'material-ui/IconButton';
import { ListItem } from 'material-ui/List';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

export default class GroupListItem extends React.Component {
  render() {
    const {
      permissionCats,
      invitationCats,
      group,
      disabled,
      onOpenModal
    } = this.props;
    const permissionCount = permissionCats.filter(
      permCat => permCat === group._id
    ).length;
    const invitationCount = invitationCats.filter(
      permCat => permCat === group._id
    ).length;
    return (
      <ListItem
        primaryText={group.name}
        secondaryText={
          <p>
            {permissionCount} {permissionCount === 1 ? 'user' : 'users'},{' '}
            {invitationCount}{' '}
            {invitationCount === 1 ? 'invitation' : 'invitations'} with this
            group
          </p>
        }
        onClick={() => onOpenModal(group, permissionCount + invitationCount)}
        disabled={disabled}
        rightIconButton={
          disabled ? null : (
            <IconButton style={{ pointerEvents: 'none' }} className="list_item">
              <EditIcon color="#999999" />
            </IconButton>
          )
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Account/Groups/GroupListItem/index.jsx